// extracted by mini-css-extract-plugin
export default {"hidden":"RolesTable__hidden-li_gk","table":"RolesTable__table-zjKwz"};